import {CSSProperties} from "react";
import {Link} from "react-router";
import {Badge} from "@/components/ui/badge.tsx";
import {cn} from "@/lib/utils.ts";
import SpellImage from "@/spells/SpellImage.tsx";
import {displaySpellLevel} from "@/spells/SpellFormatting.ts";
import {SpellSummary} from "@/spells/model/Spell.ts";
import {getSchoolAttributes} from "@/spells/model/SpellSchools.ts";

export default function SpellListItem({spell, href, search, selected, style}: {
    spell: SpellSummary;
    href: string;
    search: string;
    selected: boolean;
    style?: CSSProperties;
}) {
    const school = getSchoolAttributes(spell);
    return (
        <div style={style} className="border-b border-border bg-surface">
            <Link className={cn(
                "flex h-full items-center border-l-2 border-transparent p-1 transition-colors hover:bg-accent/65",
                selected && "border-l-warning bg-warning/10",
            )} to={{pathname: href, search}}>
                <SpellImage spell={spell} size={32}/>
                <span className="grow truncate px-3 font-medium text-foreground">{spell.name}</span>
                {spell.level !== undefined && (
                    <Badge className={cn("border text-xs text-muted-foreground", school.bg, school.border)}>
                        {displaySpellLevel(spell.level)}
                    </Badge>
                )}
            </Link>
        </div>
    );
}
